<template>
  <!-- :closable="false" -->
  <a-modal v-model:visible="bindVisible" class="bindDialog" width="600px" :footer="null" @cancel="handleCancel">
    <h3>绑定手机号</h3>
    <p>登陆及找回密码的途径</p>
    <a-form ref="bindPhoneFormRef" :model="bindPhoneForm" :rules="bindPhoneFormRules" @finish="bindPhoneFinish">
      <a-form-item name="phone">
        <a-input v-model:value="bindPhoneForm.phone" size="large" placeholder="请输入手机号" allow-clear />
      </a-form-item>
      <a-form-item name="phoneCode" style="position: relative">
        <a-input v-model:value="bindPhoneForm.phoneCode" size="large" placeholder="请输入验证码" />
        <a-button type="link" class="getCodeBtn" :disabled="!rightPhone" @click="getCode">
          {{ countDownTime > 0 ? `已发送${countDownTime}s` : '获取验证码' }}
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :block="true" size="large" html-type="submit" style="margin-top: 40px">绑定并登录</a-button>
      </a-form-item>
    </a-form>
    <div class="agreement">
      登录即表示同意<a href="https://academy.yinolink.com/index/index/protocol" target="_blank">《YinoLink易诺用户服务协议》</a>
    </div>
  </a-modal>

  <a-modal wrapClassName="codeModal" v-model:visible="codeVisible" title="" width="430px" :centered="true"
    @cancel="codeModalCancel">
    <template #footer></template>
    <div class="codeBg">
      <img class="server_qrcode" :src="live_code" alt="" />
    </div>
  </a-modal>

  <!-- 注册问卷弹窗 -->
  <RegisterQuestionDialog :open="isOpenQuestionDialog" @close="closeRegisterQuestionDialog" />
</template>

<script>
import RegisterQuestionDialog from '../components/questionDialog/RegisterQuestionDialog.vue'
import { getIsWriteForm } from '../request/api/question.js'
import { handleEventTracking } from '@/request/api/common'
export default {
  name: 'BindPhoneDialog',
  data() {
    let checkMobile = async (rule, value) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      if (value === '') {
        return Promise.reject('请输入手机号')
      } else if (!regMobile.test(value)) {
        return Promise.reject('请输入有效的电话号码')
      } else {
        return Promise.resolve()
      }
    }
    return {
      bindVisible: false,
      bindPhoneForm: {
        phone: '',
        phoneCode: '',
        type: 'code',
      },
      bindPhoneFormRules: {
        phone: [{ validator: checkMobile, trigger: 'blur' }],
        phoneCode: [{ required: true, message: '请输入正确的验证码', trigger: 'blur' }],
      },
      countDownTime: 0,
      live_code: '',
      codeVisible: false,
      is_added: true,
      isOpenQuestionDialog: false, // 注册问卷弹窗
    }
  },
  computed: {
    rightPhone() {
      return /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(
        this.bindPhoneForm.phone
      )
    },
  },
  mounted() {
    this.$bus.on('bindDialog', this.openBindDialog)
  },
  methods: {
    // 获取验证码
    async getCode() {
      // 如果当前没有计时
      if (!this.countDownTime) {
        // 启动倒计时
        this.countDownTime = 60
        this.clock = window.setInterval(() => {
          this.countDownTime--
          if (this.countDownTime <= 0) {
            clearInterval(this.clock)
          }
          this.content = this.countDownTime + 's后重新发送'
        }, 1000)
        // 发送axios请求
        const { data: res } = await this.$http.post('user/login', this.bindPhoneForm)
        if (res.code == 100) {
          return this.$message.error(`${res.msg}`)
        }
      }
    },
    async bindPhoneFinish() {
      const { data: res } = await this.$http.post('user/login', {
        phone: this.bindPhoneForm.phone,
        phoneCode: this.bindPhoneForm.phoneCode,
        source: this.$route.query && this.$route.query.source ? this.$route.query.source : ''
      })
      if (res.code != 200) return this.$message.error(`${res.msg}`)
      var name = res.user.name == null ? '' : res.user.name
      var phone = res.user.phone == null ? '' : res.user.phone
      var company = res.user.company == null ? '' : res.user.company
      var email = res.user.email == null ? '' : res.user.email
      wlRegisterComp.linkToWL(
        {
          wl_qrcode_id: '1597886613810147328', // 需要使用的智能码ID
          client_user_id: res.user.phone, // 用户在贵公司平台的唯一
          sign_mode: false, // 可选参数 不传时默认false 是否校验签名
          sign: '', //string 可选参数 sign_mode为true时传输 加密后的签名
          current_time: 0, //可选参数 sign_mode为true时传输 加密签名时使用的毫秒时间戳
          formData: {
            联系人: name,
            手机号: phone,
            公司名称: company,
            邮箱: email,
          }, // 用户填写的注册或登录信息，value可以为空，但key值必填
          is_update: false, // 此次提交是否为数据更新，默认false
        },
        async (data) => {
          // live_code
          // console.log(data)
          handleEventTracking({ type: 4, phone: res.user.phone, value: JSON.stringify(data) })
          if (data.msg == '当前用户已加好友') {
            window.localStorage.setItem('userInfo', JSON.stringify(res.user))
            if (res.new === 1) await this.checkQuestionDialog()
            if (this.isOpenQuestionDialog) {
              this.isOpenLogin = false
            } else {
              location.reload()
              return
            }
          } else {
            this.live_code = data.data.live_code
            wlRegisterComp.checkUserState(
              res.user.phone, // 用户在客户平台的唯一ID
              async (data) => {
                // console.log(data)
                // is_added == false 弹出
                this.is_added = data.data.is_added
                if (data.data.is_added == false) {
                  this.codeVisible = true
                }
                window.localStorage.setItem('userInfo', JSON.stringify(res.user))
                if (res.new === 1) await this.checkQuestionDialog()
                this.isOpenLogin = false
                if (this.is_added == true) {
                  location.reload()
                }
              }
            )
          }
        }
      )
    },
    handleCancel() { },
    openBindDialog() {
      this.bindVisible = true
    },
    codeModalCancel() {
      window.location.reload()
    },
    closeRegisterQuestionDialog() {
      this.isOpenQuestionDialog = false
      if (this.codeVisible) return
      location.reload()
    },
    // 判断是否打开注册问卷弹窗
    checkQuestionDialog() {
      return new Promise((resolve) => {
        getIsWriteForm(1).then((res) => {
          if (res.code === 200 && res.type === 0) {
            this.isOpenQuestionDialog = true
          }
        }).finally(() => {
          resolve()
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.bindDialog {
  h3 {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    margin-bottom: 4px;
  }

  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    text-align: center;
    margin-bottom: 20px;
  }

  .ant-form {
    width: 272px;
    margin: 0 auto;
  }

  .getCodeBtn {
    position: absolute;
    top: 5px;
    right: 0;
  }

  .agreement {
    font-size: 12px;
    text-align: center;

    a {
      color: #3A84FF;
    }
  }
}

.codeBg {
  position: relative;
  width: 430px;
  height: 560px;
  background: url('../assets/images/popBG.png') no-repeat;
  background-size: 100%;
  margin: 0 auto;
}

.server_qrcode {
  width: 268px;
  height: 268px;
  position: absolute;
  top: 211px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
